import { Box, Button, Divider, InputAdornment, TextField, Typography } from '@mui/material';
import { BodyText, AgencyProfileSection, SubTitleText, EditAgencyProfile } from 'Application/components';
import { FC, useState } from 'react';
import logoImg from 'assets/images/Bonfire-Logo.png';
import { Add, BadgeOutlined, EmailOutlined, HowToRegOutlined, PhoneOutlined, PlaceOutlined } from '@mui/icons-material';

interface BritamAgencyAdminProfileProps {
    data: {
        name: string;
        emailAddress: string;
        phoneNumber: string;
        agentNumber: string;
        address: string;
        logoUrl?: string;
        agencyUrl: string;
        intermediaryType: string;
        branchCode: string;
    };
}

export const BritamAgencyAdminProfile: FC<BritamAgencyAdminProfileProps> = ({ data }) => {
    const profileSection: JSX.Element = (
        <Box>
            <Typography className="mb-2 text-[13px]">Name</Typography>
            <TextField
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <BadgeOutlined fontSize="small" />
                        </InputAdornment>
                    )
                }}
                size="small"
                className="mb-4 text-[13px] text-gray-800 font-semibold"
                id="agency-name"
                name="name"
                value={data.name}
                variant="outlined"
                fullWidth
                disabled
            />
            <Typography className="mb-2 text-[13px]">Email</Typography>
            <TextField
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <EmailOutlined fontSize="small" />
                        </InputAdornment>
                    )
                }}
                size="small"
                className="mb-4 text-[12px] font-light"
                id="email"
                name="email"
                value={data.emailAddress}
                variant="outlined"
                fullWidth
                disabled
            />
            <Typography className="mb-2 text-[13px]">Phone Number</Typography>
            <TextField
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <PhoneOutlined fontSize="small" />
                        </InputAdornment>
                    )
                }}
                size="small"
                className="mb-4 text-[12px] font-light"
                id="phone-number"
                name="phoneNumber"
                value={data.phoneNumber}
                variant="outlined"
                fullWidth
                disabled
            />
            <Typography className="mb-2 text-[13px]">Agent Number</Typography>
            <TextField
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <HowToRegOutlined fontSize="small" />
                        </InputAdornment>
                    )
                }}
                size="small"
                className="mb-4 text-[12px] font-light"
                id="business-reg-no"
                name="registrationNumber"
                value={data.agentNumber}
                variant="outlined"
                fullWidth
                disabled
            />
            <Typography className="mb-2 text-[13px]">Address</Typography>
            <TextField
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <PlaceOutlined fontSize="small" />
                        </InputAdornment>
                    )
                }}
                size="small"
                className="mb-4 text-[12px] font-light"
                id="address"
                name="address"
                value={data.address}
                variant="outlined"
                fullWidth
                disabled
            />
            <Typography className="mb-2 text-[13px]">Branch Code</Typography>
            <TextField
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <HowToRegOutlined fontSize="small" />
                        </InputAdornment>
                    )
                }}
                size="small"
                className="mb-4 text-[12px] font-light"
                id="business-reg-no"
                name="registrationNumber"
                value={data.branchCode}
                variant="outlined"
                fullWidth
                disabled
            />
            <Typography className="mb-2 text-[13px]">Intermediary Type</Typography>
            <TextField
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <PlaceOutlined fontSize="small" />
                        </InputAdornment>
                    )
                }}
                size="small"
                className="mb-4 text-[12px] font-light"
                id="address"
                name="address"
                value={data.intermediaryType}
                variant="outlined"
                fullWidth
                disabled
            />
        </Box>
    );

    const logoSection: JSX.Element = <img src={data.logoUrl || logoImg} alt="Agency Logo" />;

    const brandColorsSection: JSX.Element = (
        <Box>
            <Typography className="mb-2 text-[13px]">Sub-domain</Typography>
            <TextField
                className="mb-6 text-[12px] font-light"
                id="sub-domain"
                name="sub-domain"
                value={data.agencyUrl}
                variant="outlined"
                size="small"
                fullWidth
                disabled
            />
            <Typography className="mb-2 text-[13px]">Brand Colors</Typography>
            <Box className="flex items-center space-x-2">
                <Box className="p-4 bg-green-600 rounded-full" />
                <Box className="p-4 bg-blue-600 rounded-full" />
                <Box className="p-4 bg-slate-600 rounded-full" />
                <Box className="p-4 bg-fuchsia-600 rounded-full" />
                <Add className="bg-white-300 m-5 rounded-full text-sky-700 border border-slate-200" />
            </Box>
        </Box>
    );

    const [isSetEditProfileOpen, setIsEditProfileDialogOpen] = useState(false);

    const setEditProfileDialog = () => {
        setIsEditProfileDialogOpen(true);
    };

    return (
        <>
            <Box>
                <Box className="flex flex-wrap justify-between items-center">
                    <Box className="flex flex-col space-y-2">
                        <SubTitleText text={'Agency Profile'} />
                        <BodyText text={"View the agency's profile information"} />
                    </Box>
                    <Button className="mt-2 sm:mt-0" disableElevation variant="contained" onClick={() => setEditProfileDialog()}>
                        Edit
                    </Button>
                </Box>
                <Divider className="my-6" />
                <AgencyProfileSection title={'Public Profile'} description={"Agency's profile details"} content={profileSection} />
            </Box>
            <EditAgencyProfile isOpen={isSetEditProfileOpen} setIsOpen={setIsEditProfileDialogOpen} profileData={data} />
        </>
    );
};
